import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default function useSessionHistory() {
  const { login_history, logout_history } = useSelector((state: any) => state.session);
  return useMemo(() => {
    return [
      ...(login_history || []).map((h) => ({ ...h, type: 'login' })),
      ...(logout_history || []).map((h) => ({ ...h, type: 'logout' })),
    ].sort((a, b) => {
      const dateA = a.type === 'login' ? a.time_of_issue : a.time_of_invalidation;
      const dateB = b.type === 'login' ? b.time_of_issue : b.time_of_invalidation;
      if (dateA < dateB) return 1;
      if (dateB < dateA) return -1;
      return 0;
    });
  }, [logout_history, login_history]);
}
